import React, { Component } from 'react';
import './AddTask.css'

class AddTask extends Component {
    state = {
        task: ''
    };

    handleInputChange = e => {
        this.setState({ task: e.target.value });
    };

    handleSubmit = e => {
        e.preventDefault();
        this.props.onAddTask(this.state.task);
        this.setState({ task: '' });
    };
    // handleButton(e) {
    //     e.preventDefault();
    //     console.log('You clicked submit.');
    // }

    render() {
        return (
            <div className='card'>
                <form onSubmit={this.handleSubmit}>
                    <input className='input'
                        type="text"
                        placeholder="Write Here"
                        value={this.state.task}
                        onChange={this.handleInputChange}
                    />
                    <button className='add' >Add Some</button>
                </form>
            </div>
        );
    }
}

export default AddTask;